<template>
  <div class="component-content configuration-saddle">
    <div class="component-content-scroll">
      <div class="component-content-title mb-4">Select your saddle</div>

      <b-tabs content-class="mt-3" v-model="currentInternalStep">
        <b-tab
          title="Saddle"
          active
          v-if="(typeof this.components.saddle != 'undefined')"
        >
          <div>
            <option-list
              :options="saddleInput"
              :target="this.results.saddle"
              :inputName="'setpost'"
              v-on:target-updated="updateSaddle"
            ></option-list>
          </div>
        </b-tab>
        <b-tab
          title="Tape"
          v-if="(typeof this.components.bartape != 'undefined')"
        >
          <div>
            <option-list
              :options="bartapeInput"
              :target="this.results.bartape"
              :inputName="'bartape'"
              v-on:target-updated="updateBartape"
              v-if="this.components.bartape"
            ></option-list>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-saddle",
  data() {
    return {
      currentInternalStep: 0,
      totalInternalTabs: 0,
    };
  },
  components: {
    OptionList,
  },
  props: ["configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      if (this.results.saddle==null) {
        this.$emit('set-error', 'Please select a saddle');
        return false;
      }
      if (this.currentInternalStep == 1 && this.results.bartape==null) {
        this.$emit('set-error', 'Please select a bartape');
        return false;
      }
      if (this.currentInternalStep < this.totalInternalTabs - 1) {
        this.currentInternalStep++;
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentInternalStep > 0) {
        this.currentInternalStep--;
      } else {
        this.$emit("go-back");
      }
    },
    updateSaddle: function (e) {
      this.saddleInput = e;
    },
    updateBartape: function (e) {
      this.bartapeInput = e;
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    saddleInput: {
      get: function () {
        return this.components.saddle[0];
      },
      set: function (e) {
        this.$emit("set-saddle", e);
      },
    },
    bartapeInput: {
      get: function () {
        return this.components.bartape[0];
      },
      set: function (e) {
        this.$emit("set-bartape", e);
      },
    }
  },
  mounted: function() {
    setTimeout(()=> {
      this.totalInternalTabs=document.querySelectorAll('.nav-tabs .nav-item').length;
    }, 100) ;
  }
};
</script>

<style lang="scss" scoped>
.configuration-saddle {
}
</style>

